import React from "react";

export default function Pagination(props) {
  const { goToPage, onNextClick, onPrevClick, page, perPage, total, totalCapped, updating } = props;
  const totalPages = Math.ceil(total / perPage);
  return (
    <div className="row">
      <div className="col-xs-4">{page > 1 && <button disabled={updating} onClick={() => onPrevClick()} className="btn btn-link">Prev</button>}</div>
      <div className="col-xs-4 text-center" style={{ paddingTop: 8 }}>
        Total: {total.toLocaleString()}{totalCapped && "+"} Page: {goToPage ? (
          <select
            disabled={updating}
            onChange={(e) => goToPage(Number(e.target.value))}
            value={page}
          >
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
              <option key={p} value={p} disabled={p === page}>
                {p}
              </option>
            ))}
          </select>
        ) : page} / {totalPages}
      </div>
      <div className="col-xs-4 text-right">{(page * perPage) < total && <button disabled={updating} onClick={() => onNextClick()} className="btn btn-link">Next</button>}</div>
    </div>
  );
}
